import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Errors, LeaderboardService } from '../../../core';

@Component({
  selector: 'app-leaderboard-challenge-tab',
  templateUrl: './leaderboard-challenge-tab.component.html',
  styleUrls: ['./leaderboard-challenge-tab.component.scss']
})
export class LeaderboardChallengeTabComponent implements OnInit, OnChanges {

  @Input() userData: any;
  @Input() isOptOut: boolean = false;
  @Input() isActive: boolean = false;

  errors: Errors = { errors: {} };
  leaderboardChgData: any;

  private hasLoaded: boolean = false;

  constructor(private leaderboardService: LeaderboardService) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isActive'] && this.isActive && !this.hasLoaded) {
      this.hasLoaded = true;
      this.getLeaderboardChallengeList();
    }
  }

  getLeaderboardChallengeList() {
    const userType = localStorage.getItem('selectedRole') === 'seller' ? '/seller/' : '/manager/';
    const compId = this.userData.company.id;
    const req = userType + this.userData.id;
    this.leaderboardService.getLeaderboardChallengeList(req + '?companyId=' + compId).subscribe((res) => {
      this.leaderboardChgData = { leaderTab: 'LCD', data: res, type: 'LCD' };
    }, (err) => {
      this.errors = err;
    });
  }
}
